import { format, parseISO } from 'date-fns';
import { Loader } from 'rsuite';
import { Tag } from '../../../../../components/Tag';
import { useLastIntegration } from '../../hooks/useLastIntegration';
import { LastIntegration } from '../../types';
import styles from './LastIntegrationTag.module.scss';

const ENGINE_STATUS_SKINS: Record<LastIntegration['engineStatus'], 'red' | 'green'> = {
  NOT_UPDATED: 'red',
  UPDATING: 'red',
  UPDATED: 'green',
};

export const LastIntegrationTag = () => {
  const { data, isLoading } = useLastIntegration();

  if (isLoading)
    return (
      <Tag className={styles.tag}>
        <span>Carregando informação...</span>
        <Loader size="xs" />
      </Tag>
    );

  if (!data?.lastExecutionDate)
    return (
      <Tag className={styles.tag} skin="red">
        Sem informações
      </Tag>
    );

  return (
    <Tag className={styles.tag} skin={ENGINE_STATUS_SKINS[data.engineStatus]} size="xsmall">
      atualizado em {format(parseISO(data.lastExecutionDate), 'dd/MM/yyy, HH:mm')}
    </Tag>
  );
};
